import PropTypes from 'prop-types';
import styled from 'styled-components';
import { stylePropType } from '@adsk/alloy-react-theme';
import TreeNode from '../TreeNode';
var VirtualizableTreeNode = styled(TreeNode).attrs(function (p) {
  return {
    style: {
      height: p.size,
      transform: "translateY(".concat(p.start, "px)")
    }
  };
}).withConfig({
  displayName: "VirtualizableTreeNode",
  componentId: "sc-158syg4-0"
})(["position:absolute;top:0;left:0;transition:transform 300ms;width:100%;"]);
VirtualizableTreeNode.displayName = 'VirtualizableTreeNode';
VirtualizableTreeNode.propTypes = {
  style: stylePropType,
  className: PropTypes.string,
  size: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired
};
export default VirtualizableTreeNode;
//# sourceMappingURL=VirtualizableTreeNode.js.map